/* Custom Product Slider Script - Enable Dots */
if (!customElements.get('custom-product-slider')) {
  class CustomProductSlider extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.setupProductGallery);
    }

    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container?.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Wait for Flickity to load
      if (typeof Flickity === 'undefined') {
        setTimeout(() => this.connectedCallback(), 100);
        return;
      }

      this.setOptions();
      this.init();
    }

    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail') || [];
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: true,
        fade: false,
        cellSelector: '.product-images__slide.is-active',
        draggable: true,
        freeScroll: false,
        setGallerySize: true
      };
    }

    init() {
      this.flkty = new Flickity(this, this.options);
      this.selectedIndex = this.flkty.selectedIndex;

      // Force dots creation
      if (this.flkty.pageDots) {
        this.flkty.pageDots.setDots();
      }

      this.setupEvents();
      this.setupProductGallery();
    }

    setupEvents() {
      const _this = this;

      this.video_containers.forEach((container) => {
        container.querySelector('button')?.addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });

      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });

      this.flkty.on('change', (index) => {
        let previous_slide = this.flkty.cells[_this.selectedIndex]?.element;
        let previous_media = previous_slide?.querySelector('.product-single__media');

        if (previous_media?.classList.contains('product-single__media-external-video')) {
          let video = previous_media.querySelector('iframe');
          if (video) {
            video.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo' }), '*');
          }
        }

        if (previous_media?.classList.contains('product-single__media-native-video')) {
          let video = previous_media.querySelector('video');
          if (video) video.pause();
        }

        _this.selectedIndex = index;
      });
    }

    setupProductGallery() {
      // Gallery setup logic if needed
    }
  }

  customElements.define('custom-product-slider', CustomProductSlider);
}
